import React, { useState, useEffect } from 'react';

import SmartConLogo from '../../assets/img/SmartCon__logo.svg';
import SCphoto1 from '../../assets/img/SCphoto1.jpg';
import SCphoto2 from '../../assets/img/SCphoto2.jpg';
import SCphoto3 from '../../assets/img/SCphoto3.jpg';
import SCphoto4 from '../../assets/img/SCphoto4.jpg';
import userIcon from '../../assets/img/user.svg';
import downArrowIcon from '../../assets/img/down-arrow.svg';
import micIcon from '../../assets/img/mic.svg';

import './SmartCon.scss'

const SmartCon = () => {
  const versionList = [
    {
      version: '1.0',
      description: [
        'Добавили базовый функционал, который был утверждён заказчиком',
      ],
    },
    {
      version: '1.01',
      description: [
        'Исправили мелкие баги с отображением информации на устройствах Samsung a51',
        'Добавили счётчик выполненных заданий',
      ],
    },
    {
      version: '1.02',
      description: [
        'Исправили мелкие баги с отображением информации на устройствах Xiaomi',
        'Добавили быстрый поиск',
        'Добавили фонарик',
      ],
    },
  ];

  // State to keep track of the current version index
  const [currentVersionIndex, setCurrentVersionIndex] = useState(0); // Start with the first version (index 0)

  // Function to navigate to the next version
  const handleNextVersion = () => {
    setCurrentVersionIndex((prevIndex) =>
      (prevIndex + 1) % versionList.length // Loop back to the start if at the end
    );
  };

  // Function to navigate to the previous version
  const handlePrevVersion = () => {
    setCurrentVersionIndex((prevIndex) =>
      (prevIndex - 1 + versionList.length) % versionList.length // Loop to the end if at the start
    );
  };

  // Get the current version data based on the index
  const currentVersion = versionList[currentVersionIndex];

  return (
    <section className="smartcon">
      <div className="container">
        <div className="smartcon__container">
          <div className="smartcon__descr-wrapper">
            <img src={SmartConLogo} alt="smartcon-logo" />
            <div className="smartcon__descr">
              <h1 className="title">
                SmartCon
              </h1>
              <p className="smartcon__descr-text">
                Создан для улучшения качества обслуживания населения.
                С помощью приложения вы можете подавать заявки для получения государственных услуг
              </p>
            </div>
          </div>
          <div className="line-smartcon"></div>

          <div className="info__block">
            <div className="info__descr">
              Описание проблемы которая существует у заказчика
            </div>
            <div className="info__text vertical-line">
              Мы тратим слишком много времени на обработку показаний. Процесс сбора и обработки данных, даже для нас самих не всегда прозрачен. Мы чувствуем, что нашу работу можно улучшить технически, но не знаем, как именно (С) Представитель смарткона
            </div>
            <div className="info__photo">
              <img src={SCphoto1} alt="photo1" />
            </div>
          </div>

          <div className="info__block">
            <div className="info__descr">
              Результат анализа деятельности заказчика
            </div>
            <div className="info__text">
              Мы изучили должностные инструкции всех задействованных работников. Построили схемы движения процесса сбора показаний. Показали результаты заказчику и получили ответ — На самом деле все не совсем так. И нам пришлось переработать весь процесс, но уже на основе реальной работы всех сотрудников. Мы ходили вместе с контролёрами. Сидели в кабинетах вместе с инженерами и диспетчерами за анализом и сводом балансов. Подсматривали какие документы и сколько по времени их подписывают. У кого и сколько каждый документ лежит в стопке перед тем как его подпишет один из руководителей.
            </div>
            <div className="info__photo">
              <img src={SCphoto2} alt="photo2" />
            </div>
          </div>

          <div className="info__block">
            <div className="info__subtitle">
              К каким результатам мы пришли?
            </div>
            <div className="info__text">
              <ul>
                <li>1–2 дня формируются Списки обхода потребителей.</li>
                <li>В течении 2 дней они не спешно идут сверху в низ и распределяются по районам и попадают к контролёрам.</li>
                <li> Контролёр обходит абонентов 1–3 дня. и записывает данные в нужную ячейку на бумаге. Параллельно теряя листочки. Попадая под дождь. Иногда на стол вместе с вкуснейшими шымкентскими баурсаками.</li>
                <li>1–2 дня заполненные списки подписываются инженерами и другими руководителями</li>
                <li>Подписанные списки попадают к операторам ТОО Омега XXI которые вносят каждое из 600 000 показаний по Туркестанской области и города Шымкент вручную. На самом деле труд титанический.</li>
                <li>После этого данные попадают в билинг где обновляется баланс и печатаются квитанции. Которые далее с помощью тех же контролёров попадают к нам всем в двери и почтовые ящики.</li>
              </ul>
            </div>

            <div className="info__subtitle">
              Мы обсудили с руководством и выделили то что даст максимальный эффект в общем по проекту
            </div>
            <div className="info__text">
              <ul>
                <li>Все будем переводить в цифру. Отказываемся от бумажных носителей и ручных подписей. Все в электронный формат и срочно!</li>
                <li>Даём полный онлайн доступ ко всем вносимым изменениям Руководству и диспетчерам в ту же секунду.</li>
                <li>Отслеживаем геолокацию в момент передачи каждого показания с мобильного устройства контролёра. Что бы диспетчер мог убедится при проверке, что контролёр действительно там был.</li>
                <li>Внедряем максимальные упрощения для контролёра — поиск заданий по сканированию штрих кода, хранение истории, возможность взаимодействовать.</li>
              </ul>
            </div>

            <div className="info__photo">
              <img src={SCphoto3} alt="photo3" />
            </div>
          </div>

          <div className="info__block">
            <div className="info__descr">
              Описание предложенных решений
            </div>
            <div className="info__text">
              Подготовили минимально работоспособный продукт. Вложив свою душу в проект. На наш взгляд получилось — классно. Что мы с воодушевлением продемонстрировали заказчику.
              скриншоты, схемы В итоге мы разработали мобильное приложение контролёра и вэб версию кабинета диспетчера в каждом районе. Настроили роль центрального диспетчера, который мог смотреть все данные в реальном времени в разрезе каждого Района.
            </div>
            <div className="info__photo">
              <img src={SCphoto4} alt="photo4" />
              <div className="info__photo-descr">Часть админ-сайт диспечера и мобильного приложения</div>
            </div>
          </div>

          <div className="info__block">
            <div className="info__descr">
              Обратная связь
            </div>
            <div className="info__text">
              Получили, как всегда, гору негатива от пользователей. Однако руководство Энергопоток увидело все долгосрочные плюсы уже на столь раннем этапе. Поэтому получили добро на дальнейшую работу. Руководство донесло обо всех преимуществах нововведений каждому сотруднику компании. Вот тогда то, мы и получили объёмную помощь от всех участников процесса. Сформировали команду у Заказчика и ответственных за тестирование. Тестировали все очень долго, как всегда. Люди редко хотят изменений в своей работе, хоть они и упрощают их жизнь.
              Пришли с совещания собрали все заметки, замечания и предложения, которые озвучили. Просмотрели протокол. И сели за улучшение
            </div>
          </div>

          <div className="info__block">
            <div className="info__descr">
              Описание улучшений продукта —  техническая поддержка
            </div>
            <div className="version__block">
              <div className="version__viewport">
                {/* Dynamically render the current version's description */}
                <div data-version={currentVersion.version} className="version__descr">
                  <ul>
                    {currentVersion.description.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="version__wrapper">
                <div className="version__number">
                  Version <span id="version-number">{currentVersion.version}</span>
                </div>
                <div className="version__buttons">
                  <button className="btn btn_prev" onClick={handlePrevVersion}></button>
                  <button className="btn btn_next" onClick={handleNextVersion}></button>
                </div>
              </div>
            </div>
          </div>

          <div className="info__block">
            <div className="info__descr">
              Обратная связь
            </div>
            <div className="dialog__wrapper">
              <div className="dialog">
                <div className="dialog__question question">
                  <div className="question__name">
                    <img src={userIcon} alt="user" className="question__logo" />
                    Диспетчер Абайского района
                  </div>
                  <p className="question__text">
                    Нужно решить проблему необхода потребителей. Сейчас это не удобно.
                  </p>
                </div>
                <div className="dialog__arrow">
                  <img src={downArrowIcon} alt="arrow" />
                </div>
                <div className="dialog__answer answer">
                  <div className="answer__name">
                    <img src={micIcon} alt="mic" className="answer__logo" />
                    Тех поддержка SmartCon
                  </div>
                  <p className="answer__text">
                    Да есть такая проблема. Мы собрали всех для решения этой проблемы. Перестраиваем архитектуру запросов и передачи нарядов. Но перед этим ждём пока все это согласует каждый руководитель. Нельзя решить проблему без учёта мнения всех сторон.
                  </p>
                </div>
              </div>

              <div className="dialog">
                <div className="dialog__question question">
                  <div className="question__name">
                    <img src={userIcon} alt="user" className="question__logo" />
                    Контролёр Енбекши:
                  </div>
                  <p className="question__text">
                    Добавьте фонарик в приложение.В подъездах и электрических щитках часто очень темно. Приходится закрывать приложение и включать фонарик.
                  </p>
                </div>
                <div className="dialog__arrow">
                  <img src={downArrowIcon} alt="arrow" />
                </div>
                <div className="dialog__answer answer">
                  <div className="answer__name">
                    <img src={micIcon} alt="mic" className="answer__logo" />
                    Тех поддержка SmartCon
                  </div>
                  <p className="answer__text">
                    Оу класс! Спасибо за идею. Мы её реализовали в новой версии приложения. Пожалуйста обновите приложение через плей маркет.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SmartCon;
